/**
 * 2023.11.21删除处理页码问题
 **/
 function handleDeletePage(total, pageSize, pageNum) {
  // feat:2023.06.14 处理删除完一整页的数据后，实际页码还在当前页问题
  //feat:2023.06.14 计算操作后的总页数
  const totalPage = Math.ceil((total - 1) / pageSize);
  // 原本点击的页码是否超出了操作后的总页数，若超出设当前点击的页码为最后一页，若没超 页码不变
  const currentPage = pageNum > totalPage ? totalPage : pageNum
  // 设置的当前页码是否小于1，若小于则设当前页码为1，若不小于1 则采用计算的页码
  pageNum = currentPage < 1 ? 1 : currentPage
  return pageNum
};
/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return;
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return;
    return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return;
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return '';
    }
};

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
};

/**
 * 导出
 **/


 //身份证18位验证
 function isIdentityId(identityId){
  
   var patrn = /(^\d{15}$)|(^\d{17}(\d|X|x)$)/;//长度或格式校验
     //地区校验
     var aCity = {
       11: "北京",
       12: "天津",
       13: "河北",
       14: "山西",
       15: "内蒙古",
       21: "辽宁",
       22: "吉林",
       23: "黑龙江",
       31: "上海",
       32: "江苏",
       33: "浙江",
       34: "安徽",
       35: "福建",
       36: "江西",
       37: "山东",
       41: "河南",
       42: "湖北",
       43: "湖南",
       44: "广东",
       45: "广西",
       46: "海南",
       50: "重庆",
       51: "四川",
       52: "贵州",
       53: "云南",
       54: "西藏",
       61: "陕西",
       62: "甘肃",
       63: "青海",
       64: "宁夏",
       65: "新疆",
       71: "台湾",
       81: "香港",
       82: "澳门",
       91: "国外"
     };
     // 出生日期验证
     var sBirthday = (
       identityId.substr(6, 4) +
       "-" +
       Number(identityId.substr(10, 2)) +
       "-" +
       Number(identityId.substr(12, 2))
     ).replace(/-/g, "/"),
       d = new Date(sBirthday)
     // 身份证号码校验 最后4位  包括最后一位的数字/字母X
     var sum = 0,
       weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
       codes = "10X98765432";
     for (var i = 0; i < identityId.length - 1; i++) {
       sum += identityId[i] * weights[i];
     }
     var last = codes[sum % 11]; //计算出来的最后一位身份证号码

     var errorMsg = '';
     if (identityId === '') {
       errorMsg = "身份证号不能为空"
     } else if (!patrn.exec(identityId)) {
       errorMsg = "你输入的身份证长度或格式错误"
     } else if (!aCity[parseInt(identityId.substr(0, 2))]) {
       errorMsg = "你的身份证地区非法"
     } else if (sBirthday != d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()) { errorMsg = "身份证上的出生日期非法" } else if (identityId[identityId.length - 1] != last) {
       errorMsg = "你输入的身份证号非法"
     }
     return errorMsg;

 }

 //   2024-03-25 过了树形数据
function filterTree(arr, keyword,first=true) {
  if(first){//首次传入深度克隆数据防止修改源数据
     arr=JSON.parse(JSON.stringify(arr)) 
  }
  let emptyArr = [];
  for (let item of arr) {
    if (item.departmentName&&item.departmentName.includes(keyword)) {
    //   if (item.deps &&Array.isArray(item.deps)&& item.deps.length > 0) {
    //     item.deps = this.filterTree(item.deps, keyword,false);
    //   }
      emptyArr.push(item);
    }else if(item.terminalCode&&item.terminalCode.includes(keyword)){
      emptyArr.push(item);
    }else if (item.deps&&Array.isArray(item.deps) && item.deps.length > 0) {
      item.deps = filterTree(item.deps, keyword,false);
      if (item.deps.length) {
        emptyArr.push(item);
      }
    }
  }
  return emptyArr;
}




export {
    timestampToTime,
    setStore,
    getStore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    isIdentityId,
    handleDeletePage,
    filterTree,
}



// WEBPACK FOOTER //
// ./src/utils/util.js